<template>
  <vx-card>
    <div class="vx-col mt-6 mb-6 w-full">
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Shipment Document</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <div class="vx-col w-1/3">
            <vs-input
              class="w-full"
              v-model="table.data.shipment_number"
              :disabled="true"
              v-validate="'required'"
            />
          </div>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Shipment Date</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <div class="vx-col w-1/3">
            <vs-input
              class="w-full"
              v-model="table.data.delivery_plan_date"
              :disabled="true"
              type="date"
              v-validate="'required'"
            />
          </div>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span># of DO/PI</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <div class="vx-col w-1/3">
            <vs-input
              class="w-full"
              v-model="table.data.of_do"
              :disabled="true"
              v-validate="'required'"
            />
          </div>
        </div>
      </div>
    </div>

    <hr />
    <div class="vx-col mt-6 mb-6 w-full">
      <vs-table :data="table.dataLine" stripe>
        <template slot="thead">
          <vs-th>DO/PI Number</vs-th>
          <vs-th>Ship-to Name</vs-th>
          <vs-th>Ship-to Address</vs-th>
          <vs-th>SKU Code/Name</vs-th>
          <vs-th>HU</vs-th>
          <vs-th>QTY</vs-th>
          <vs-th v-for="(vehicle, index) in table.data.vehicle_add" :key="index"
            >{{ vehicle.vehicle_number }}- {{ vehicle.driver_name }}</vs-th
          >
        </template>
        <template slot-scope="slotProps">
          <vs-tr v-for="(row, index) in slotProps.data" :key="index">
            <vs-td>{{ row.delivery_order_code }}</vs-td>
            <vs-td>{{ row.shipto_name }}</vs-td>
            <vs-td>{{ row.shipto_address }}</vs-td>
            <vs-td>
              {{ row.item_code }}-{{ row.item_name }}
              <div v-if="row.showQtyError" style="color: red; font-size: 12px">
                Total distributed quantity must equal to the quantity.
              </div>
            </vs-td>
            <vs-td>{{ row.item_unit }}</vs-td>
            <vs-td>{{ row.quantity }}</vs-td>
            <vs-td
              v-for="(vehicle, indextr) in row.vehicle_distribution"
              :key="'tt' + indextr"
            >
              <vs-input
                v-model="vehicle.quantity"
                type="number"
                :min="0"
                :max="row.quantity"
                @input="checkValue($event, row, indextr)"
                :disabled="!showData"
              ></vs-input>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
    <div class="vx-row mt-8">
      <div class="vx-col w-full flex justify-end">
        <div
          class="min-w-[350px] bg-white rounded-lg shadow-lg p-6 border border-gray-200"
        >
          <h4 class="mb-4 font-semibold text-lg text-primary flex items-center">
            <i class="feather icon-truck mr-2 text-primary"></i>
            Vehicle Pickup Summary
          </h4>
          <div
            v-if="
              Array.isArray(table.data.vehicle_add) &&
              table.data.vehicle_add.length
            "
          >
            <div
              v-for="(vehicle, vIdx) in table.data.vehicle_add"
              :key="'vehicle-summary-' + vIdx"
              class="mb-4 p-4 rounded-lg bg-gradient-to-r from-blue-50 to-blue-100 border border-blue-200 shadow-sm"
            >
              <div class="flex items-center mb-2">
                <i class="feather icon-truck text-blue-500 mr-2"></i>
                <span class="font-bold text-blue-700">
                  {{
                    vehicle && vehicle.vehicle_number
                      ? vehicle.vehicle_number
                      : "N/A"
                  }}
                </span>
                <span class="mx-2 text-gray-400">|</span>
                <span class="text-gray-700">
                  {{
                    vehicle && vehicle.driver_name ? vehicle.driver_name : "N/A"
                  }}
                </span>
              </div>
              <div class="ml-6">
                <template v-if="getVehicleUnitSummary(vIdx).length">
                  <div
                    v-for="(unitSummary, idx) in getVehicleUnitSummary(vIdx)"
                    :key="'unit-summary-' + vIdx + '-' + idx"
                    class="flex items-center text-sm text-gray-700 mb-1"
                  >
                    <i class="feather icon-package text-blue-400 mr-1"></i>
                    <span class="font-medium">{{ unitSummary.qty }}</span>
                    <span class="ml-1">{{ unitSummary.unit }}</span>
                  </div>
                </template>
                <template v-else>
                  <div class="text-gray-400 italic text-sm">
                    <i class="feather icon-info mr-1"></i>No items assigned.
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="text-gray-400 italic text-center py-4">
              <i class="feather icon-alert-circle mr-1"></i>No vehicles
              available.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/5 w-full space-x-4">
        <vs-button @click="saveData" color="primary" v-if="showData"
          >Save</vs-button
        >
        <vs-button @click="resetData" color="warning" v-if="showData"
          >Reset</vs-button
        >
      </div>
    </div>
  </vx-card>
</template>

<script>
export default {
  props: {
    ID: {
      type: Number,
    },
  },
  mounted() {
    this.getData();
  },
  data() {
    return {
      table: this.tableDefaultState(),
      showData: true,
      vehicleAdd: [],
      vehicleIsinsert: false,
    };
  },
  watch: {},
  methods: {
    tableDefaultState() {
      return {
        data: [],
        dataLine: [],
        dataLineTemp: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalPage: 0,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
      };
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get("/api/wms/v1/transport-code/detail-load-distribution/" + this.ID)
        .then((res) => {
          console.log("response", res);
          this.table.data = res.data;
          this.showData = this.table.data.status == "waiting" ? true : false;
          console.log("showData", this.showData);
          const itemLines = this.table.data.delivery_order_line.flatMap(
            (order) =>
              order.item_line.map((item) => ({
                delivery_order_id: order.delivery_order_id,
                delivery_order_code: order.delivery_order_code,
                shipto_name: order.shipto_name,
                shipto_address: order.shipto_address,
                item_code: item.item_code,
                item_name: item.item_name,
                item_unit: item.item_unit,
                quantity: item.quantity,
                item_unit_id: item.item_unit_id,
                vehicle_distribution: item.vehicle_distribution,
              }))
          );

          const seenDeliveryOrderIds = new Set();
          this.table.dataLine = itemLines.map((item) => {
            const isDuplicate = seenDeliveryOrderIds.has(
              item.delivery_order_id
            );
            seenDeliveryOrderIds.add(item.delivery_order_id);
            return {
              ...item,
              qtyCounting: item.quantity,
              delivery_order_code: isDuplicate ? "" : item.delivery_order_code,
              shipto_name: isDuplicate ? "" : item.shipto_name,
              shipto_address: isDuplicate ? "" : item.shipto_address,
              isedited: item.vehicle_distribution != null ? true : false,
            };
          });

          this.table.dataLine.forEach((item) => {
            console.log("pppppp", item.isedited);
            if (!item.isedited) {
              //looping value on vehicle_add and append to item.vehicle_distribution
              var itemDescr = [];
              this.table.data.vehicle_add.forEach((vehicle, index) => {
                itemDescr.push({
                  vehicle_id: vehicle.vehicle_id,
                  vehicle_number: vehicle.vehicle_number,
                  driver_id: vehicle.driver_id,
                  driver_name: vehicle.driver_name,
                  quantity: 0,
                });
              });
              itemDescr[0].quantity = item.quantity;
              item.vehicle_distribution = itemDescr;
            }
            if (!this.vehicleIsinsert) {
              this.vehicleAdd = item.vehicle_distribution;
              this.vehicleIsinsert = true;
            }
          });

          if (!this.vehicleIsinsert && this.vehicleAdd.length != 0) {
            this.table.data.vehicle_add = this.vehicleAdd;
          }
          this.table.data.vehicle_add = this.vehicleAdd;

          //duplicate dataLine to dataLineTemp
          this.table.dataLineTemp = JSON.parse(
            JSON.stringify(this.table.dataLine)
          );
          console.log("table2", this.table.dataLine);
          this.$vs.loading.close();
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: err.response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
        });
    },
    saveData() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure to Save this data?",
        accept: (e) => {
          this.save();
        },
      });
    },
    save() {
      // Check on dataLine if total quantity is less than the dataLine.quantity
      let hasError = false;
      this.table.dataLine.forEach((row) => {
        const totalQty = row.vehicle_distribution.reduce(
          (sum, item) => sum + Number(item.quantity),
          0
        );
        if (totalQty !== row.quantity) {
          this.$set(row, "showQtyError", true);
          hasError = true;
        } else {
          this.$set(row, "showQtyError", false);
        }
      });
      if (hasError) {
        // Optionally, scroll to first error or focus
        return;
      }

      var dataConvert = [];
      this.table.dataLine.forEach((item) => {
        var vehicle_distribution = [];
        var groupedItems = dataConvert.find(
          (data) => data.delivery_order_id === item.delivery_order_id
        );

        if (!groupedItems) {
          groupedItems = {
            delivery_order_id: item.delivery_order_id,
            item_line: [],
          };
          dataConvert.push(groupedItems);
        }

        var itemLine = groupedItems.item_line.find(
          (line) => line.item_unit_id === item.item_unit_id
        );

        if (!itemLine) {
          itemLine = {
            item_unit_id: item.item_unit_id,
            item_code: item.item_code,
            item_name: item.item_name,
            item_unit: item.item_unit,
            vehicle_data: [],
          };
          groupedItems.item_line.push(itemLine);
        }

        item.vehicle_distribution.forEach((vehicle) => {
          itemLine.vehicle_data.push({
            vehicle_id: vehicle.vehicle_id,
            driver_id: vehicle.driver_id,
            quantity: vehicle.quantity,
          });
        });
      });
      console.log("dataConvert", dataConvert);

      const postData = {
        transport_plan_id: this.ID,
        delivery_order_data: dataConvert,
      };
      console.log("postData", postData);
      this.$vs.loading();
      this.$http
        .post("/api/wms/v1/transport-code/load-distribution", postData)
        .then((res) => {
          if (res.code == 200) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Success",
              text: "Data has been saved",
              iconPack: "feather",
              icon: "icon-check",
              color: "success",
              position: "top-right",
            });
            this.$emit("close");
          } else {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Error",
              text: res.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            });
          }
        });
    },
    checkValue(event, row, index) {
      // Parse the new value and ensure it's not negative
      let newQty = Math.max(0, Number(event) || 0);
      row.vehicle_distribution[index].quantity = newQty;

      // Calculate total distributed except current
      let totalOther = row.vehicle_distribution.reduce(
        (sum, item, idx) => (idx === index ? sum : sum + Number(item.quantity)),
        0
      );
      let remain = row.quantity - newQty - totalOther;

      // If over, need to reduce the biggest (except current)
      if (remain < 0) {
        // Find index of max quantity except current
        let maxIdx = -1;
        let maxQty = -1;
        row.vehicle_distribution.forEach((item, idx) => {
          if (idx !== index && Number(item.quantity) > maxQty) {
            maxQty = Number(item.quantity);
            maxIdx = idx;
          }
        });
        if (maxIdx !== -1) {
          // Reduce the max to fit
          let reduceBy = Math.min(maxQty, Math.abs(remain));
          row.vehicle_distribution[maxIdx].quantity = maxQty - reduceBy;
        }
        // Recalculate remain
        totalOther = row.vehicle_distribution.reduce(
          (sum, item, idx) =>
            idx === index ? sum : sum + Number(item.quantity),
          0
        );
        remain = row.quantity - newQty - totalOther;
        // If still over, repeat (in case of multiple max)
        if (remain < 0) {
          // Sort all except current by quantity desc
          let sorted = row.vehicle_distribution
            .map((item, idx) => ({ idx, qty: Number(item.quantity) }))
            .filter((x) => x.idx !== index && x.qty > 0)
            .sort((a, b) => b.qty - a.qty);
          for (let i = 0; i < sorted.length && remain < 0; i++) {
            let reduce = Math.min(sorted[i].qty, Math.abs(remain));
            row.vehicle_distribution[sorted[i].idx].quantity -= reduce;
            remain += reduce;
          }
        }
        // this.$vs.notify({
        //   title: "Info",
        //   text: "Total distributed quantity adjusted to match available quantity.",
        //   iconPack: "feather",
        //   icon: "icon-alert-circle",
        //   color: "warning",
        //   position: "top-right",
        // });
      }

      // After adjustment, if all are zero, set first to total qty
      if (
        row.vehicle_distribution.every((item) => Number(item.quantity) === 0)
      ) {
        row.vehicle_distribution[0].quantity = row.quantity;
      }

      // Update qtyCounting (remaining qty)
      row.qtyCounting =
        row.quantity -
        row.vehicle_distribution.reduce(
          (sum, item) => sum + Number(item.quantity),
          0
        );
    },
    resetData() {
      this.table.dataLine = JSON.parse(JSON.stringify(this.table.dataLineTemp));
    },
    getVehicleUnitSummary(vehicleIdx) {
      // vehicleIdx is the index of the vehicle in vehicle_add
      const summary = {};
      this.table.dataLine.forEach((row) => {
        if (
          row.vehicle_distribution &&
          row.vehicle_distribution[vehicleIdx] &&
          Number(row.vehicle_distribution[vehicleIdx].quantity) > 0
        ) {
          const unit = row.item_unit;
          const qty = Number(row.vehicle_distribution[vehicleIdx].quantity);
          if (!summary[unit]) {
            summary[unit] = 0;
          }
          summary[unit] += qty;
        }
      });
      // Convert to array of { unit, qty }
      return Object.entries(summary).map(([unit, qty]) => ({ unit, qty }));
    },
  },
};
</script>
<style>
.vl {
  border-left: 6px solid black;
  height: 100%;
}
</style>
